export interface Job {
    id: ID;
    status: JobStatus;
}

export enum JobStatus {
    NEW = "new",
    PROCESSING = "processing",
    COMPLETED = "completed",
    ERROR = "error",
    STALE = "stale",
}
